/* Deviceli: About page. Replaces pageCompany() from dv-app.js. */
window.pageCompany = function(){
  var I = function(n){ return typeof ico === 'function' ? ico(n, 22) : ''; };
  var promises = [
    ['check','Tested by hand','Every device is checked before it ships. Every grade works 100%.'],
    ['shield','12-month warranty','Parts and labour, on every device we sell.'],
    ['rotate','30-day returns','Changed your mind? Send it back for a full refund.'],
    ['battery','Battery 80%+','On phones, tablets, laptops and watches.']
  ];
  var grades = [
    ['#137A42','Excellent','Almost no signs of use. Flawless screen, micro-scratches on the body invisible from 20 cm.'],
    ['#0F3068','Good','Light signs of use. Flawless screen, light micro-scratches on the body invisible from 50 cm.'],
    ['#B7791F','Fair','Visible signs of use. Scratches or small dents on the body, light screen scratches visible only when it is on.']
  ];
  var steps = [
    ['Pick your device','Choose the model, storage, colour and grade. The price you see is the price you pay.'],
    ['We ship it','Tracked delivery anywhere in Canada, free over C$100.'],
    ['Try it for 30 days','Not right for you? Send it back and get a full refund.'],
    ['Covered for 12 months','Parts and labour are covered. If something goes wrong, just get in touch.']
  ];
  return `
  <div class="abhero"><div class="wsin abrise">
    <p class="k">About Deviceli</p>
    <h1>Hi, we’re Deviceli.</h1>
    <p class="lede">We make refurbished the obvious choice: the phone, tablet or laptop you want, tested by hand, for a lot less than new, with the same peace of mind.</p>
    <div class="acts"><a class="p" href="#/shop">Shop refurbished</a><a class="s" href="#/sell">Sell a device</a></div>
  </div></div>

  <div class="abwrap">
    <section class="absec abstory abrise">
      <div>
        <p class="k">Our story</p>
        <h2>Good tech deserves a second life.</h2>
      </div>
      <div>
        <p>Most phones and laptops are replaced long before they stop working. A device that has been checked properly can keep going for years. What usually stops people is trust: who tested it, how worn is the battery, and what happens if something goes wrong?</p>
        <p>Deviceli was started to answer those questions. We buy devices back, test each one by hand, grade it honestly and sell it with a 12-month warranty and 30 days to change your mind. Buying refurbished should feel as safe as buying new, and cost a lot less.</p>
      </div>
    </section>

    <section class="absec abrise">
      <p class="k">Our promise</p>
      <h2>The same peace of mind as new.</h2>
      <p class="sub">Whatever you buy, and whichever grade you choose.</p>
      <div class="abgrid">${promises.map(function(x){ return `<div><span class="ic">${I(x[0])}</span><b>${x[1]}</b><p>${x[2]}</p></div>`; }).join('')}</div>
    </section>

    <section class="absec abrise">
      <p class="k">Honest grades</p>
      <h2>A grade describes looks. Never how it works.</h2>
      <p class="sub">Every grade is 100% functional. The only difference is how the device looks, and the price.</p>
      <div class="abgrades">${grades.map(function(g){ return `<div><b><i style="background:${g[0]}"></i>${g[1]}</b><p>${g[2]}</p></div>`; }).join('')}</div>
    </section>

    <section class="absec abrise">
      <p class="k">How it works</p>
      <h2>Simple from start to finish.</h2>
      <ol class="absteps">${steps.map(function(s,i){ return `<li><small>0${i+1}</small><b>${s[0]}</b><p>${s[1]}</p></li>`; }).join('')}</ol>
    </section>

    <section class="absec abrise">
      <p class="k">Get started</p>
      <h2>Buy, sell or buy in bulk.</h2>
      <div class="abdoors">
        <a href="#/shop"><b>Shop refurbished</b><p>iPhone, Galaxy, iPad, MacBook and more, graded and warrantied.</p><span>Shop now ›</span></a>
        <a href="#/sell"><b>Sell your device</b><p>Answer a few questions and get a firm offer in about a minute.</p><span>Get an offer ›</span></a>
        <a href="#/wholesale"><b>Wholesale</b><p>Graded, unlocked stock by the lot for businesses.</p><span>See stock ›</span></a>
      </div>
    </section>

    <section class="absec abfacts abrise">
      <div>
        <p class="k">The company</p>
        <h2>Who’s behind Deviceli</h2>
        <p class="sub">Deviceli is the retail brand of MobileBuyback Inc., a federally incorporated Canadian company.</p>
        <div class="acts"><a class="btn" href="#/care/contact">Contact us</a><a class="seclink" href="#/care">Help centre</a></div>
      </div>
      <dl>
        <div><dt>Legal name</dt><dd>MobileBuyback Inc.</dd></div>
        <div><dt>Brand</dt><dd>Deviceli</dd></div>
        <div><dt>Incorporation</dt><dd>Federal, 2026</dd></div>
        <div><dt>Business number</dt><dd>72282 5239</dd></div>
        <div><dt>Head office</dt><dd>Ottawa, Ontario</dd></div>
        <div><dt>Ships to</dt><dd>Anywhere in Canada</dd></div>
      </dl>
    </section>
  </div>`;
};
(function(){
  function rise(){
    var els = document.querySelectorAll('.abrise:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  if (typeof route === 'function' && typeof DV_VIEW !== 'undefined' && DV_VIEW === 'about') { route(); rise(); }
})();
